<template>
  <div>
    <nav aria-label="Page navigation example" class="mb-3" v-if="count>1">
      <ul class="pagination pagination-rounded mb-3 justify-content-center">
        <li :class="[ current==1 ? 'page-item disabled' : 'page-item']">
          <button class="page-link" @click="$emit('pages', current-1)" tabindex="-1">
            <i class="ti-angle-right"></i>
          </button>
        </li>
        <li v-for="num in pageCount" aria-current="page"
          :class="[ current == num ? 'page-item active' : 'page-item']" :key="num">
          <button class="page-link" @click="$emit('pages', num)" v-text="num"></button>
        </li>

        <li :class="[current==count ? 'page-item disabled' : 'page-item']">
          <button class="page-link" @click="$emit('pages', current+1)">
            <i class="ti-angle-left"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: ['count', 'current'],
  computed: {
    pageCount () {
      if (this.count <= 9) {
        return this.count
      } else if (this.current <= 3) {
        return [1, 2, 3, 4, 5, 6, '...', this.count - 1, this.count]
      } else if (this.count - 3 <= this.current) {
        return [1, 2, '...', this.count - 5, this.count - 4, this.count - 3, this.count - 2, this.count - 1, this.count]
      } else {
        return [1, 2, '...', this.current - 1, this.current, this.current + 1, '....', this.count - 1, this.count]
      }
    }
  }
}
</script>
